<template>

<com-item name="players.weights" :size="size" :is-empty="!active" :loading="loading" title="Average Weight" :has-more="weights.total > 5" v-on:more="onMoreClick">

	<template v-slot:about>

		<p>Average weight of games by each player.</p>

	</template>

	<template v-slot:stats>

		<div class="weight">

			<div class="weight-visual">

				<app-visualisation-segments :data="polar" v-if="isPolar" v-on:click="onSegmentClick" />
				<app-visualisation-bars :data="bars" v-if="!isPolar" v-on:click="onBarsClick" />

			</div>

			<div class="weight-list">

				<div class="weight-loading"><i class="fa fa-spinner fa-spin" v-if="isLoadingPlayers" /></div>

				<div class="weight-empty" v-if="!isLoadingPlayers && !weights.players.length">No players.</div>

				<template v-if="!isLoadingPlayers">

					<app-user type="player" :item="item" v-for="(item, index) in weights.players" :subtext="'Average weight of ' + item.weight" count-text="play" :key="index" />

				</template>

			</div>

		</div>
		
	</template>

	<template v-slot:buttons>

		<com-toggle :options="weightOptions" :value="weightValue" v-on:change="onWeightChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	data: function() {

		return {
			polar: {
				areas: [
					{title: 'Light', subtitle: '1.0 - 2.0'},
					{title: 'Light-Medium', subtitle: '2.0 - 3.0'},
					{title: 'Medium', subtitle: '3.0 - 4.0'},
					{title: 'Heavy', subtitle: '4.0 - 5.0'}
				],
				selected: 0,
				clickable: true,
				size: 16,
				shades: [
					'rgba(17, 105, 135, 0.2)',
					'rgba(17, 105, 135, 0.4)',
					'rgba(17, 105, 135, 0.6)',
					'rgba(17, 105, 135, 0.8)',
					'rgba(17, 105, 135, 1)'
				],
				segments: [],
				dataset: {
					data: []
				}
			},
			bars: {
				datasets: [
					{ type: 'bar', data: [], backgroundColor: '#4881bb', tooltip: '{{value}} player{{value.plural}} <small>Weight between {{x.tooltip}}</small>' }
				],
				axis: {
					x: {
						labels: [],
						long: true,
						action: 'click',
						selected: 0,
					},
					y: {
						min: 10,
						points: 10
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		isLoadingPlayers: function() {

			return this.fetching === 'weight.band'

		},

		isPolar: function() {

			return this.$store.getters['filter/insights/players/weight/chart'] === 'polar'

		},

		weights: function() {

			return this.$store.getters['page/insights/players/weights']

		},

		active: function() {

			return this.weights.data.length && !this.loading

		},

		weightOptions: function() {

			var options = []

			options.push({value: this.$CONSTANTS.INSIGHTS.GRAPH.POLAR, text: 'Polar chart'})
			options.push({value: this.$CONSTANTS.INSIGHTS.GRAPH.BAR, text: 'Bar chart'})

			return options

		},

		weightValue: function() {

			return this.$store.getters['filter/insights/players/weight/chart']

		},

		band: function() {

			return this.$store.getters['filter/insights/players/weight/band']

		}

	},

	watch: {

		band: function(n) {

			this.polar.selected = n
			this.bars.axis.x.selected = n

		},

		weights: function() {

			this.visualise()

		}

	},

	created: function() {

		var range

		for (var i=1; i <= 16; i++) {

			if (i == 16) {

				range = '{{value}} player{{value.plural}} ' + (((i - 1) * 0.25) + 1).toFixed(2) + ' and higher'

			} else {

				range = '{{value}} player{{value.plural}} between ' + (((i - 1) * 0.25) + 1).toFixed(2) + ' and ' + (((i - 1) * 0.25) + 1 + 0.24).toFixed(2)

			}

			this.polar.segments.push({
				label: range
			})

			range = (((i - 1) * 0.25) + 1).toFixed(2) 

			this.bars.axis.x.labels.push({
				label: range + ' - ' + (((i - 1) * 0.25) + 1.24).toFixed(2) ,
				tooltip: range + ' and ' + (((i - 1) * 0.25) + 1.24).toFixed(2) 
			})

		}

		this.polar.selected = this.band
		this.bars.axis.x.selected = this.band

		this.visualise()

	},

	methods: {

		visualise: function() {

			this.polar.dataset.data = this.weights.data
			this.bars.datasets[0].data = this.weights.data

		},

		onBarsClick: function(value) {

			this.$store.commit('filter/insights/players/weight/band', value)

		},

		onSegmentClick: function(value) {

			this.$store.commit('filter/insights/players/weight/band', value)

		},

		onWeightChange: function(value) {

			this.$store.commit('filter/insights/players/weight/chart', value)

		},

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersWeight'
			})
		
		}

	}

}

</script>

<style scoped>

.weight {
	display: grid;
	grid-template-columns: 320px 1fr;
	height: 100%;
}

.weight-list {
	border-left: 1px solid #eee;
}

.is-small-mobile .weight {
	grid-template-columns: 1fr;
	grid-template-rows: 300px auto;
}

.is-small-mobile .weight-list {
	border-left: 0px;
	border-top: 1px solid #eee;
}

.weight-loading {
	position: absolute;
	width: 40px;
	height: 40px;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.weight-loading i {
	font-size: 24px;
	transform-origin: 50% 50%;
	color: #ffc563;
}

.weight-empty {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 16px;
	font-weight: 400;
	color: #ccc;
}

</style>